import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  shotsPageModals: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  formControl: {
    alignItems: "center",
    justifyContent: "center",
    width: "250px",
    height: "40px",
    background: theme.palette.secondary.light,
    borderRadius: "10px",
  },

  dropdownDiv: {
    display: "flex",
    alignItems: "center",
    width: "250px",
    background: theme.palette.secondary.light,
  },

  selectText: {
    marginLeft: "10px",
    fontFamily: "Nunito Sans",
    opacity: "0.7",
  },
  formLabelText: {
    height: "0%",
    width: "100%",
    opacity: "0",
    background: theme.palette.secondary.light,
    fontFamily: "Nunito Sans",
    fontStyle: "normal",
  },
}));

export default useStyles;
